import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ProdutoExcel(produtos) {
  // Mapeia os dados para o mesmo formato do PDF
  const dados = produtos.map((produto) => ({
    Código: produto.COD_PRODUTO,
    Nome: produto.DESCRICAO,
    Ncm: produto.NCM,
    St: produto.ST,
    Estoque: Number(produto.ESTOQUE).toFixed(3),
    Compra: Number(produto.COMPRA).toFixed(2),
    Venda: Number(produto.VENDA).toFixed(2),
  }));

  // Cria worksheet (planilha)
  const worksheet = XLSX.utils.json_to_sheet(dados);

  // Define larguras de coluna (opcional)
  worksheet["!cols"] = [
    { wch: 10 },  // Código
    { wch: 40 },  // Nome
    { wch: 12 },  // Ncm
    { wch: 6 },   // St
    { wch: 10 },  // Estoque
    { wch: 12 },  // Compra
    { wch: 12 },  // Venda
  ];

  // Cria o arquivo com a planilha
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Relatório");

  // Gera e salva o arquivo
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "Relatorio_Produtos.xlsx");
}

export default ProdutoExcel;